import { Pipe, PipeTransform } from '@angular/core';
import { ProductService } from '../services/product/product.service';
import { Product } from '../services/entities';

@Pipe({
  name: 'filterProductsBy',

  pure: false
})
export class FilterProductsByPipe implements PipeTransform {
  constructor(private productService: ProductService) {}

  transform(products: Product[], ageCategoryId: number, productCategoryId?: number): Product[] {
    return this.productService.filterProductsBy(products, ageCategoryId, productCategoryId).sort();
  }
}
